module.exports = __webpack_public_path__ + "img/cal-female-condom.17edab80.png";